app.service('deliveryValidateCity', function (loading, console, modal, deliveryValidateServices) {

	function scrollToAddressValidate(data) {
		var $scroll = false;
		var $form = $('.delivery-form-fields');
		var $address = $('.address-info');
		var $delivery = $('.delivery-address');
		var $invoice = $('.invoice-data-form');

		$('#short-client-data').remove();
		
		if (!data.isAddressValid) {
			$scroll = $address;
			$form.addClass('home-address-invalid').find('.home-address-invalid-message').show();
		} else {
			$form.removeClass('home-address-invalid').find('.home-address-invalid-message').hide();
		}

		if (!data.isDeliveryAddressValid) {
			$scroll = $scroll ? $scroll : $delivery;
			$form.addClass('delivery-address-invalid').find('.delivery-address-invalid-message').show();
		} else {
			$form.removeClass('delivery-address-invalid').find('.delivery-address-invalid-message').hide();
		}
		if (!data.isInvoiceAddressValid) {
			$scroll = $scroll ? $scroll : $invoice;
			$form.addClass('invoice-address-invalid').find('.invoice-address-invalid-message').show();
		} else {
			$form.removeClass('invoice-address-invalid').find('.invoice-address-invalid-message').hide();
		}
		if ($scroll) {
			$.scrollTo($scroll, 800);
		}
	}

	function incorrectCityCodeConfirm(data, config) {
		modal.generate({
			id: 'modal-adress-validate',
			content: '<div class="content">' + data.message + '</div>',
			buttons: [
				{
					text: 'Tak',
					cssClass: 'btn-second js-close-modal',
					click: function () {
						scrollToAddressValidate(data);
					}
				},
				{
					text: 'Nie, idę dalej',
					cssClass: 'btn-third js-close-modal',
					click: function () {
						deliveryValidateServices.validate(config);
					}
				}
			]
		});
	}
	function incorrectCityCodeEdit(data) {
		modal.generate({
			id: 'modal-adress-validate',
			header: false,
			content: $.trim(data.message),
			buttons: [
				{
					text: 'Edytuj',
					cssClass: 'btn-third js-close-modal'
				}
			]
		});
	}
	function incorrectCityCodeError(data) {
		modal.generate({
			id: 'modal-adress-validate',
			header: false,
			content: $.trim(data.message),
			buttons: [
				{
					text: 'Rozumiem',
					cssClass: 'btn-second js-close-modal'
				}
			]
		});
	}
	function validateSuccess(data, config) {
		console.log('SPRAWDZANIE POPRAWNOŚCI KODU DO MIASTA - OK');
		if (data !== '' && data.message !== "") {
			loading.stop();
			if (!data.blockPaymentStep) {
				if (!config.isAnyProductElectronicSoftwareDistribution && !config.isAnyStandalonService) {
					incorrectCityCodeConfirm(data, config);
				} else {
					incorrectCityCodeEdit(data);
				}
			} else {
				incorrectCityCodeError(data);
			}

		}
		else {
			deliveryValidateServices.validate(config);
		}
	}
	function validateError() {
		console.log('SPRAWDZANIE POPRAWNOŚCI KODU DO MIASTA - ERROR');
		loading.stop();
		modal.alert('Błąd walidacji danych adresowych. Prosimy spróbować ponownie');
	}
	function validate(config) {
		var $countryCode = $('#country-code');
		var $cityName = $('#city-name');
		var $zipCode = $('#zip-code');
		var $street = $('#home-address-street');
		var $invoiceCityName = $('#invoice-city-name');
		var $invoiceZipCode = $('#invoice-zip-code');
		var $invoiceCountryCode = $('#invoice-country-code');
		var $invoiceAddressStreet = $('#invoice-street');
		var checkInvoice = false;
		var options = {};

		$.extend(options, {
			cityName: $cityName.val(),
			zipCode: $zipCode.val(),
			street: $street.val(),
			isDelivery: false,
			isInvoice: false,
			checkHomeAddress: $countryCode.val() === "PL"
		});

		// dodatkowy warunek sprawdzajacy czy nie ma danych adresowych ale sa dane do faktury
		if ((!$cityName.length) && ($invoiceCityName.length && $invoiceZipCode.length && $invoiceCityName.val().length && $invoiceZipCode.val().length)) {
			checkInvoice = true;
		}
		if (!config.deliveryInfo.deliveryEqualsHome && $('#delivery-city-name').length && $('#delivery-zip-code').length) {
			options.isDelivery = true;
			options.deliveryCityName = $('#delivery-city-name').val();
			options.deliveryZipCode = $('#delivery-zip-code').val();
			options.deliveryAddressStreet = $('#delivery-street').val();
		}
		if ($invoiceCountryCode.val() === "PL" && (config.deliveryInfo.invoiceNeeded || checkInvoice)) {
			options.isInvoice = true;
			options.invoiceCityName = $invoiceCityName.val();
			options.invoiceZipCode = $invoiceZipCode.val();
			options.invoiceAddressStreet = $invoiceAddressStreet.val();
		}
		if ((options.deliveryCityName && options.deliveryZipCode) || (options.cityName && options.zipCode) || checkInvoice) {
			$.ajax({
				url: '/order-path-validate-address-integrity.ltr',
				data: options,
				success: function (data) {
					validateSuccess(data, config);
				},
				error: function () {
					validateError();
				}
			});
		} else {
			deliveryValidateServices.validate(config);
		}
	}

	return {
		validate: validate
	};
});
